const subnav = {
    init() {
        const subnavEl = document.querySelector(".mental-health-subnav");
        const subnavTitle = document.querySelector(
            ".mental-health-subnav__hed",
        );

        function updateSubnavIndicator(number) {
            console.log("update indicator #" + number);

            document
                .querySelectorAll(".mental-health-subnav__indicator-line")
                .forEach((indicator, index) => {
                    indicator.classList.remove(
                        "mental-health-subnav__indicator-line--current",
                    );

                    if (index + 1 == number) {
                        indicator.classList.add(
                            "mental-health-subnav__indicator-line--current",
                        );
                    }
                });
        }

        /**
         * @param {HTMLElement} element
         */
        function updateSubnavReason(element) {
            // update text
            if (subnavTitle) {
                subnavTitle.innerHTML = element.innerHTML;
            }

            // update indicator
            const currentSection = element.closest(".-js-section"); // get parent section
            if (currentSection?.classList.contains("section1")) {
                updateSubnavIndicator(1);
            } else if (currentSection?.classList.contains("section2")) {
                updateSubnavIndicator(2);
            } else if (currentSection?.classList.contains("section3")) {
                updateSubnavIndicator(3);
            }

            // make sure subnav is visible
            showSubnav();
        }

        function showSubnav() {
            subnavEl?.classList.remove("mental-health-subnav--inactive");
        }

        function hideSubnav() {
            subnavEl?.classList.add("mental-health-subnav--inactive");
        }

        /**
         * @param {HTMLElement} element
         */
        function findPreviousReason(element) {
            const currentSection = element.closest(".-js-section"); // get parent section

            // Start by checking the previous sibling of the current section
            let section = currentSection?.previousElementSibling;

            // Traverse through previous siblings until we find a match or run out of siblings
            while (section) {
                if (section.matches(".-js-section")) {
                    return section.querySelector(".-js-section-reason"); // Return the matching section
                }
                section = section.previousElementSibling;
            }

            return null; // No matching section found
        }

        // subnav intersection observer
        // (show/hide)
        const subnavIntersectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (
                        !entry.isIntersecting &&
                        entry.boundingClientRect.top < 0
                    ) {
                        updateSubnavReason(entry.target);
                    } else if (entry.isIntersecting) {
                        // find previous reason, update subnav if one is found
                        const previousReason =
                            findPreviousReason(entry.target) || null;
                        if (previousReason) {
                            updateSubnavReason(previousReason);
                        } else {
                            hideSubnav();
                        }
                    }
                });
            },
        );

        const sectionTitles = document.querySelectorAll(".-js-section-reason");
        sectionTitles.forEach((sectionTitle) => {
            subnavIntersectionObserver.observe(sectionTitle);
        });
    },
};

export default subnav;
